import { classNames } from 'primereact/utils';
import { useLocation, useNavigate } from 'react-router-dom';

type ComponentIdProps = {
  componentId?: string;
  ownProductId?: string;
  href?: string;
};

export default function ComponentId({
  componentId,
  ownProductId,
  href,
}: ComponentIdProps): JSX.Element | null {
  if (!componentId) {
    return null;
  }

  const navigate = useNavigate();
  const location = useLocation();

  const secondaryComponentId = ownProductId ?? null;

  const onComponentIdClick = () => {
    if (href) {
      const pathname = location.pathname;
      const search = location.search;

      navigate(href, { state: { from: `${pathname}${search}` } });
    }
  };

  return (
    <div className='flex flex-column justify-content-center'>
      <div
        className={classNames(
          'font-normal',

          {
            'cursor-pointer': !!href,
            'hover:underline': !!href,
          },
        )}
        onClick={onComponentIdClick}
      >
        {componentId}
      </div>
      {secondaryComponentId && (
        <div className='white-space-nowrap overflow-hidden text-overflow-ellipsis w-full font-normal font-italic text-gray-600'>
          {secondaryComponentId}
        </div>
      )}
    </div>
  );
}
